import {getWriterInfo,getWritersList,newWriter,getWriterCV,upDataWriterInfo,getWriterRank,updataWriterComment,getWriterContact} from '@/api/writer'


const state = {
};

const mutations = {
};

const actions = {
  getwritercontact({ commit },params){
    return new Promise((resolve, reject) => {
      getWriterContact(params).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatawritercomment({ commit },data){
    return new Promise((resolve, reject) => {
      updataWriterComment(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getwriterrank({ commit },data){
    return new Promise((resolve, reject) => {
      getWriterRank(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatawriterinfo({ commit },data){
    return new Promise((resolve, reject) => {
      upDataWriterInfo(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getwriterinfo({ commit },params){
    return new Promise((resolve, reject) => {
      getWriterInfo(params).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getwritercv({ commit },wid){
    return new Promise((resolve, reject) => {
      getWriterCV(wid).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getwriterslist({ commit },data){
    return new Promise((resolve, reject) => {
      getWritersList(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newwriter({ commit },data){
    return new Promise((resolve, reject) => {
      newWriter(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
};


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
